import type { ICrmResponse } from "~/interfaces"
import { DateTime } from "luxon";

export const crmMapping = {
    clientId: (data: ICrmResponse) => {
        return data.cliente_id
    },
    name: (data: ICrmResponse) => {
        return data.Nome
    },
    surname: (data: ICrmResponse) => {
        return data.Cognome
    },
    taxCode: (data: ICrmResponse) => {
        return data.CF
    },
    cellphone: (data: ICrmResponse) => {
        return data.Phone
    },
    email: (data: ICrmResponse) => {
        return data.EMail
    },
    citizenship: (data: ICrmResponse) => {
        return data.cittadinanza
    },
    address: (data: ICrmResponse) => {
        return data.Indirizzo
    },
    addressCap: (data: ICrmResponse): string => {
        return `${data.CAP}`
    },
    addressCity: (data: ICrmResponse) => {
        if (!data.City || !data.Prov) return null
        return `${data.City} (${data.Prov})`
    },
    iban: (data: ICrmResponse) => {
        return data.Iban?.includes('*') ? null : data.Iban
    },
    maskedIban: (data: ICrmResponse) => {
        return data.Iban?.includes('*') ? data.Iban : null
    },
    identityType: (data: ICrmResponse) => {
        return data.Doc_Type
    },
    documentNumber: (data: ICrmResponse) => {
        return data.Doc_Number?.includes('*') ? null : data.Doc_Number
    },
    maskedDocumentNumber: (data: ICrmResponse) => {
        return data.Doc_Number?.includes('*') ? data.Doc_Number : null
    },
    documentCity: (data: ICrmResponse) => {
        if (!data.Doc_City || !data.Doc_Prov) return null
        return `${data.Doc_City} (${data.Doc_Prov})`
    },
    documentExpire: (data: ICrmResponse) => {
        if (!data.Doc_Data_End_Day || !data.Doc_Data_End_Month || !data.Doc_Data_End_Year)
            return null;

        return DateTime.local(
            data.Doc_Data_End_Year,
            data.Doc_Data_End_Month,
            data.Doc_Data_End_Day
        ).toFormat("dd/MM/yyyy");
    },
    documentRelease: (data: ICrmResponse) => {
        if (!data.Doc_Data_Day || !data.Doc_Data_Month || !data.Doc_Data_Year)
            return null;
        
        return DateTime.local(
            data.Doc_Data_Year,
            data.Doc_Data_Month,
            data.Doc_Data_Day
        ).toFormat("dd/MM/yyyy");
    },
    isDocumentExpired: (data: ICrmResponse): boolean => {
        if (!data.Doc_Data_End_Day || !data.Doc_Data_End_Month || !data.Doc_Data_End_Year)
            return false;

        return DateTime.local(
            data.Doc_Data_End_Year,
            data.Doc_Data_End_Month,
            data.Doc_Data_End_Day
        ) < DateTime.now();
    },
    isExpireDateMissing: (data: ICrmResponse): boolean => {
        return !data.Doc_Data_End_Day || !data.Doc_Data_End_Month || !data.Doc_Data_End_Year
    },
    pageBlock: (data: ICrmResponse) => {
        return data.page_block
    }
}